const english = { text: 'English', code: 'en' };
const arabic = { text: 'العربية', code: 'ar' };
const bahasa = { text: 'Bahasa Indonesia', code: 'id' };
const spanish = { text: 'Spanish', code: 'es' };
const french = { text: 'French', code: 'fr' };
const hindi = { text: 'Hindi', code: 'hi' };
const malaysian = { text: 'Malaysian', code: 'ms' };
const portuguese = { text: 'Portuguese (Angola)', code: 'pt' };

const uzbek = { text: 'Uzbek', code: 'uz' };
const urdu = { text: 'Urdu', code: 'ur' };
const languages = [
  english,
  arabic,
  bahasa,
  spanish,
  french,
  hindi,
  malaysian,
  portuguese,
  urdu,
  uzbek,
];

export {
  english,
  arabic,
  bahasa,
  spanish,
  french,
  hindi,
  malaysian,
  portuguese,
  uzbek,
  urdu,
};
export default languages;
